import React, { useRef } from "react";

const ACTION_DEDUPLICATION_DELAY = 500;

const noop = () => null;

export default function SelectMenuActionButton({ children, onAction = noop }) {
    const lastActionTimeRef = useRef(0);

    const stopSelectEvent = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleAction = (event) => {
        stopSelectEvent(event);

        const now = Date.now();
        if (now - lastActionTimeRef.current < ACTION_DEDUPLICATION_DELAY) {
            return;
        }

        lastActionTimeRef.current = now;
        onAction();
    };

    return (
        <button
            type="button"
            className="cursor-pointer btn btn-link btn-block py-2"
            onClick={handleAction}
            onMouseDown={stopSelectEvent}
            onPointerDown={stopSelectEvent}
            onTouchEnd={handleAction}
        >
            {children}
        </button>
    );
}
